export default __webpack_public_path__ + "static/media/Restaurant-Renaissance.0384638d.PNG";